import { paymentType as PaymentTypes } from '@ourbranch/lookups';

// Installments per term for each installment plan. Monthly is one per month of the term, so it
// always reads "of each month".
const installmentsPerTerm = (paymentType, termMonths) =>
  ({
    [PaymentTypes.QuarterTerm]: 4,
    [PaymentTypes.HalfTerm]: 2,
    [PaymentTypes.Monthly]: termMonths
  })[paymentType];

const monthsBetweenInstallments = (paymentType, termMonths) =>
  termMonths / installmentsPerTerm(paymentType, termMonths);

/**
 * How often the remaining installments are charged, e.g. "every 3 months". It follows the policy
 * term (#36200): a 12-month half-term bills every 6 months, but a 6-month auto term split into 2
 * payments bills every 3 months — the same interval billing's getPaymentIntervalMonths schedules.
 */
export const installmentFrequencyText = (paymentType, termMonths = 12) =>
  paymentType === PaymentTypes.Monthly
    ? 'of each month'
    : `every ${monthsBetweenInstallments(paymentType, termMonths)} months`;

/** The renewal premium each installment covers, e.g. "quarterly" or "3-month". */
export const installmentPremiumName = (paymentType, termMonths = 12) => {
  if (paymentType === PaymentTypes.Monthly) {
    return 'monthly';
  }
  if (paymentType === PaymentTypes.QuarterTerm && termMonths === 12) {
    return 'quarterly';
  }
  return `${monthsBetweenInstallments(paymentType, termMonths)}-month`;
};
